import React, { Component } from "react";
import "./no-subscription.component.css"
export class NoSubscription extends Component {
    render() {
        const { title, customClass, hideIcon, noOverviewContainer }=this.props
        return(
            <div className={` ${customClass} ${noOverviewContainer ? '' : 'subscription-overview-container'} no-subscription-container`}>
                {hideIcon ? <div><br /><br /><br /></div> :
                    <div className="lds-default">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                }
                <h1 className="no-subscription-label">{title}</h1>
            </div>
        );
    }
}